window.fecha = require('fecha');
import HotelDatepicker from 'hotel-datepicker';
var datepicker;

document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector("#datepicker") !== null) {
        let disabledDates;
        let noCheckInDates;
        let noCheckOutDates;

        fetch('/api/reservations/disabled-dates')
        .then(response => response.json())
        .then(data => {            
            disabledDates = data.disabledDates;
            noCheckInDates = data.noCheckInDates;
            noCheckOutDates = data.noCheckOutDates;
            document.querySelector("#datepicker_loading").classList.add("hidden");
            datepicker = new HotelDatepicker(document.getElementById("datepicker"), {
                minNights: 1,
                preventContainerClose: true,
                autoClose: false,
                disabledDates: disabledDates,
                noCheckInDates: noCheckInDates,
                noCheckOutDates: noCheckOutDates,
                moveBothMonths: true,
                hoveringTooltip: false,
                startOfWeek: 'monday',
                i18n: {
                    selected: 'Váš pobyt:',
                    night: 'Noc',
                    nights: 'Noci',
                    button: 'Zavřít',
                    'checkin-disabled': 'Příjezd není možný',
                    'checkout-disabled': 'Odjezd není možný',
                    'day-names-short': ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
                    'day-names': ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
                    'month-names-short': ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Zaří', 'Říjen', 'Listopad', 'Prosinec'],
                    'month-names': ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Zaří', 'Říjen', 'Listopad', 'Prosinec'],
                    'error-more': 'Délka pobytu by něměla být delší než 1 noc',
                    'error-more-plural': 'Délka pobytu by něměla být delší než %d nocí',
                    'error-less': 'Délka pobytu by něměla být kratší než 1 noc',
                    'error-less-plural': 'Délka pobytu by něměla být kratší než %d nocí',
                    'info-more': 'Vyberte délku pobytu (min. 1 noc)',
                    'info-more-plural': 'Vyberte délku pobytu (min. %d noci)',
                    'info-range': 'Vyberte délku pobytu mezi (%d až %d nocí)',
                    'info-default': 'Vyberte délku pobytu'
                },
                onSelectRange: function() {
                    calculatePrice(datepicker.getValue());
                }
            });
            datepicker.open();
        })
        .catch(function (error) {
            console.log(error);
        })
    }
})

function calculatePrice(date) {
    document.querySelector("#pricePreview").innerHTML = '<i class="animate-spin fas fa-spinner"></i>';
    document.querySelector("#reservationSubmit").disabled = "disabled";

    let res = date.split(" - ");
    let from = new Date(res[0]);
    let to = new Date(res[1]);

    fetch('/api/reservations/calculate-price?from='+from.getFullYear()+"-"+(from.getMonth()+1).toString()+"-"+from.getDate()+'&to='+to.getFullYear()+"-"+(to.getMonth()+1).toString()+"-"+to.getDate())
    .then(response => response.json())
    .then(data => {
        if (data.from+" - "+data.to != date) datepicker.setRange(data.from, data.to);
        if (data.blocked == true || data.alreadyReserved == true) {
            document.querySelector("#pricePreview").innerHTML = "Pro dané datum nelze rezervovat";
            document.querySelector("#reservationSubmit").disabled = "disabled";
        } else if (data.customDate == true) {
            document.querySelector("#pricePreview").innerHTML = "Pro vybrané datum nás kontaktujte";
            document.querySelector("#reservationSubmit").disabled = "disabled";
        } else {
            document.querySelector("#pricePreview").innerHTML = data.priceTotal+" "+data.currency;
            document.querySelector("#reservationData").value = data.encrypted;
            document.querySelector("#reservationSubmit").disabled = null;
        }
    })
    .catch(function (error) {
        document.querySelector("#pricePreview").innerHTML = "Někde nastala chyba";
        console.log(error);
    });
}